export const CONSTANTS = {
    MAX_UPLOAD_FILESIZE: 30 * 1024 * 1024,
    SWITCHED_TIMESTAMP: new Date('2024-04-17T00:00:00.000Z'),
};
export const DEBUG_PROJECT_API_KEYS = {
    PROD_KARTE_IN_KARTE_API_KEY: '73836f0a7f9b2161cb78d5295dfc21c7',
    EVA_BLOCKS_PROJECT_API_KEY: '06ab2066733f7dd90f2adf3fdccc858c',
    BLOCKS_DOGFOODING_API_KEY: 'e199376c76ba131d15912674b8f16f76',
    PROD_BLOCKS_DOGFOODING_API_KEY: 'd4245b7cbb76e3595a3801bc4d5a39c6',
    PROD_BLOCKS_DOGFOODING_FOR_REDESIGN_API_KEY: '0a26470d54c7002b47ac71dc83e3dfb5',
    TEST_TOKYO_REGION_API_KEY: '086297423c7b2ba24d8f6806fe28a30c',
    EVA_TESTING_API_KEY: '1f868fe414d8f92167b7029cd3574787',
    EVA_TESTING_BLOCKS_API_KEY: '6df6760ed90f52e23ddd0e7b90f2f8bd',
    EVA_BLOCKS_BEFORE_REDESIGN_API_KEY: '5d9e1b81acaab02c447e8f19d7e1b035',
    EVA_AFTER_REDESIGN_API_KEY: '044a048c38962f6484c2002003e4a9c8',
    JJ_TESTING_API_KEY: '72fae8f760b93b37bc0476ed9c2240ee',
    RINTON_TESTING_API_KEY: 'aa1f58aa80424daa2c371bd155944067',
};
export const TEST_PROJECT_API_PROJECT_IDS = {
    SYNTHETIC_TEST_PROJECT_EVA: '64101ad4bb9d080012f86f92',
    SYNTHETIC_TEST_PROJECT_PROD: '640a82a4cfc27e00190a3ce1',
};
